// This file contains the data for the New Zealand map regions
// Each region has an ID, name, submission count, and SVG path data
export const nzRegionData = [
  {
    id: 'northland',
    name: 'Northland',
    count: 94,
    path: 'M235,145 L250,110 L265,85 L290,60 L310,50 L330,60 L345,80 L355,110 L350,140 L335,170 L315,190 L290,200 L270,190 L255,175 L240,160 Z',
  },
  {
    id: 'auckland',
    name: 'Auckland',
    count: 287,
    path: 'M270,190 L290,200 L310,210 L325,225 L330,245 L320,265 L300,275 L280,270 L265,255 L255,235 L260,210 Z',
  },
  {
    id: 'waikato',
    name: 'Waikato',
    count: 176,
    path: 'M265,255 L280,270 L300,275 L320,265 L340,275 L355,295 L360,320 L350,345 L330,360 L310,365 L290,350 L275,330 L265,300 L260,275 Z',
  },
  {
    id: 'bayofplenty',
    name: 'Bay of Plenty',
    count: 128,
    path: 'M330,360 L350,345 L360,320 L380,330 L405,345 L425,370 L430,395 L415,410 L390,415 L365,405 L345,385 Z',
  },
  {
    id: 'gisborne',
    name: 'Gisborne',
    count: 65,
    path: 'M430,395 L450,385 L470,390 L485,405 L490,425 L485,445 L465,460 L445,455 L430,440 L425,420 L415,410 Z',
  },
  {
    id: 'hawkesbay',
    name: "Hawke's Bay",
    count: 112,
    path: 'M390,415 L415,410 L425,420 L430,440 L445,455 L465,460 L470,480 L465,500 L450,515 L425,520 L405,510 L390,495 L380,475 L385,445 Z',
  },
  {
    id: 'taranaki',
    name: 'Taranaki',
    count: 87,
    path: 'M290,350 L310,365 L330,360 L345,385 L350,410 L345,435 L330,450 L310,455 L290,445 L275,425 L270,400 L275,375 Z',
  },
  {
    id: 'manawatu',
    name: 'Manawatu-Whanganui',
    count: 93,
    path: 'M345,385 L365,405 L390,415 L385,445 L380,475 L365,490 L345,495 L325,485 L310,470 L305,445 L315,425 L330,410 L345,395 Z',
  },
  {
    id: 'wellington',
    name: 'Wellington',
    count: 164,
    path: 'M365,490 L380,475 L390,495 L405,510 L425,520 L430,540 L425,560 L410,575 L390,580 L370,570 L355,555 L350,535 L355,515 Z',
  },
  {
    id: 'tasman',
    name: 'Tasman',
    count: 45,
    path: 'M345,600 L365,590 L385,595 L400,610 L405,630 L400,650 L385,665 L365,670 L345,660 L335,640 L335,620 Z',
  },
  {
    id: 'marlborough',
    name: 'Marlborough',
    count: 52,
    path: 'M400,610 L420,600 L440,605 L455,620 L460,640 L455,660 L440,675 L420,680 L400,670 L390,650 L385,630 L390,615 Z',
  },
  {
    id: 'westcoast',
    name: 'West Coast',
    count: 37,
    path: 'M345,660 L365,670 L385,665 L400,670 L410,690 L415,715 L410,740 L395,760 L375,770 L355,765 L340,750 L330,725 L335,695 Z',
  },
  {
    id: 'canterbury',
    name: 'Canterbury',
    count: 203,
    path: 'M420,680 L440,675 L455,660 L470,670 L480,690 L485,715 L480,740 L465,760 L445,770 L425,765 L410,750 L400,730 L395,705 L400,685 Z',
  },
  {
    id: 'otago',
    name: 'Otago',
    count: 97,
    path: 'M375,770 L395,760 L410,750 L425,765 L445,770 L455,785 L460,810 L455,835 L440,855 L420,865 L395,860 L375,845 L365,820 L370,795 Z',
  },
  {
    id: 'southland',
    name: 'Southland',
    count: 72,
    path: 'M375,845 L395,860 L420,865 L435,880 L440,900 L435,920 L415,935 L390,940 L365,930 L350,910 L345,885 L355,865 Z',
  },
]
